import { radar } from '@/common/log';

export enum GgPixelEnum {
    LOGIN_SUCCESS = 'AW-940131115/GV_hCImu-KMaEKuGpcAD', // 每次登录成功就报一次，未登录则不报，可以不用去重
    DETAIL_PV = 'AW-940131115/IxxDCLellKQaEKuGpcAD', // pv逻辑，刷新一次就上报一次，不用去重
    ORDER_CONFIRM_SUCCESS = 'AW-940131115/p1oHCJH0lKQaEKuGpcAD', // 确认下单成功，跳转到订单确认页
    PAY_CONFIRM_SUCCESS = 'AW-940131115/4IqsCJmZmaQaEKuGpcAD', // 订单生成成功，跳转到支付确认页、
    PAY_SUCCESS = 'AW-940131115/8fWRCJ6HlaQaEKuGpcAD', // 支付成功
}
// 方便看日志
export const LogNameConfig = {
    [GgPixelEnum.LOGIN_SUCCESS]: '登录成功上报（每次登录成功上报一次）',
    [GgPixelEnum.DETAIL_PV]: '详情页PV（每次刷新上报一次）',
    [GgPixelEnum.ORDER_CONFIRM_SUCCESS]: '确认下单成功（跳转orderConfirm前上报）',
    [GgPixelEnum.PAY_CONFIRM_SUCCESS]: '订单生成成功（submitOrder接口成功返回前上报）',
    [GgPixelEnum.PAY_SUCCESS]: '支付成功（在resultV2页获取到成功，只上报一次）',
};

export function googlePixelLog(eventName: string, params = {}) {
    (window as any).gtag('event', 'conversion', {
        send_to: eventName,
        ...params,
    });
    radar.event({
        name: 'GgPixelLog',
        params: { eventName, logName: LogNameConfig[eventName] },
    });
}
